(function ($) {
  $('.sign-up-button').on('click', function (e) {
    e.preventDefault();
    var email = $('#reg_email').val();
    var emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;

    if (!emailPattern.test(email)) {
      $('.error-message').show().text('Please enter a valid email address');
    } else {
      $('.error-message').hide();
      var $button = $(this);

      $button.addClass('loading').prop('disabled', true).text('Loading...');

      $.ajax({
        url: ajax_object.register_ajax,
        type: 'POST',
        data: {
          action: 'subscribe_to_mailchimp',
          email: email,
        },
        success: function (response) {
          if (response.success) {
            $('.step-1').hide();
            $('.woocommerce h2').hide();
            $('.register-info').hide();
            $('.register-join-info').hide();
            $('.step-2').show();
            $(
              '.woocommerce button.woocommerce-button.woocommerce-form-register__submit'
            ).css('display', 'block');
          } else {
            $('.error-message').show().text(response.data);
          }

          $button
            .removeClass('loading')
            .prop('disabled', false)
            .text('Sign up now');
        },
        error: function () {
          $('.error-message')
            .show()
            .text('An error occurred. Please try again.');

          $button
            .removeClass('loading')
            .prop('disabled', false)
            .text('Sign up now');
        },
      });
    }
  });

  $(document).ready(function () {
    var fbUsernameField = $('.facebook_username_field');
    var infoText =
      'To organise your 1-on-1 contact Alex (@alex.saunders.3114) on Facebook';

    fbUsernameField.after(
      '<div class="facebook-info-text-display" style="margin-left: 12px;">' +
        infoText +
        '</div>'
    );
  });
})(jQuery);
